import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { userEvents } from '../utils/analytics';
import './Confirmation.css';

const Confirmation = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';

  const handleCreateAccount = () => {
    userEvents.buttonClick('create_account', 'subscribe_confirmation');
  };

  const handleContinueBrowsing = () => {
    userEvents.buttonClick('continue_browsing', 'subscribe_confirmation');
  };

  return (
    <div className="newsletter-confirmation-page">
      <div className="confirmation-container">
        <div className="confirmation-content">
          <h1 className="confirmation-title">Welcome to Read The Tape!</h1>
          
          <div className="confirmation-text">
            <p>
              You've successfully signed up for our newsletter with <strong>{email}</strong>.
            </p>
            <p>
              You'll start receiving our daily market insights and analysis right away.
            </p>
            <p>
              Create an account to customize your preferences and receive personalized insights.
            </p>
          </div>

          <div className="confirmation-actions">
            <Link to="/login" className="btn-primary" onClick={handleCreateAccount}>
              Create Account
            </Link>
            <Link to="/" className="btn-secondary" onClick={handleContinueBrowsing}>
              Continue Browsing
            </Link>
          </div>

          <div className="confirmation-disclaimer">
            <p>
              Already have an account? <Link to="/login" className="page-link">Sign in here</Link>
            </p>
            <p>
              You can manage your preferences and unsubscribe anytime from your account settings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
